import APIS from '../../constant/EndPoint';
import DataTable from '../Reusable/DataTable';
import NACell from '../Reusable/DataTable/NACell';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { getKey } from '../../helpers/sessionKey';
const InvoiceList = () => {
  const navigate = useNavigate();

  const clientType = getKey('client-type');
  const defaultColumns: any = [
    {
      header: 'S.N',
      accessorKey: '.',
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: 'Statement ID',
      accessorKey: 'invoice_id',
      cell: NACell,
    },

    {
      header: 'Col. COD',
      accessorKey: 'delivery_charge.collected',
      cell: NACell,
    },
    {
      header: 'D. Charge',
      accessorKey: 'delivery_charge.charge',
      cell: NACell,
    },
    {
      header: 'Tax',
      accessorKey: 'tax',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: 'Amount',
      accessorKey: 'invoice_amount',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: 'Paid Date',
      accessorKey: 'settlement_date',
      cell: ({ row, getValue }: any) => {
        return (
          <p className={tw`text-sm `}>
            {getValue()
              ? moment(getValue()).format('YY-MM-DD HH:mm:ss')
              : 'N/A'}
          </p>
        );
      },
    },
    {
      header: 'Remarks',
      accessorKey: 'remarks',
      cell: NACell,
    },
    {
      header: 'Status',
      accessorKey: 'status',
      cell: NACell,
    },
  ];
  const cargodefaultColumns: any = [
    {
      header: 'S.N',
      accessorKey: '.',
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: 'Statement ID',
      accessorKey: 'invoice_id',
      cell: NACell,
    },
    {
      header: 'Tax Amount',
      accessorKey: 'tax',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: 'Amount',
      accessorKey: 'invoice_amount',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: 'Paid Date',
      accessorKey: 'settlement_date',
      cell: ({ row, getValue }: any) => {
        return (
          <p className={tw`text-sm `}>
            {getValue()
              ? moment(getValue()).format('YY-MM-DD HH:mm:ss')
              : 'N/A'}
          </p>
        );
      },
    },
    {
      header: 'Payment Remarks',
      accessorKey: 'remarks',
      cell: NACell,
    },
    {
      header: 'Status',
      accessorKey: 'status',
      cell: NACell,
    },
  ];
  const handleRowClick = (row) => {
    if (clientType === 'cargo') {
      navigate(`cargo-invoice-preview/${row?.original?.id}`);
    } else {
      navigate(`invoicedetail/${row?.original?.id}`);
    }
  };

  return (
    <DataTable
      url={APIS.INVOICE}
      queryKey={'Invoice'}
      columns={clientType === 'cargo' ? cargodefaultColumns : defaultColumns}
      handleRowClick={handleRowClick}
      tableName={'Invoice'}
    />
  );
};

export default InvoiceList;
